import {
  type AlertProps,
  createTheme,
  type PaletteOptions,
} from '@mui/material'
import { alpha, lighten } from '@mui/material/styles'
import type {} from '@mui/x-data-grid-pro/themeAugmentation'
import { createBaseTheme, deleteButtonStyling } from './theme-base'

export { deleteButtonStyling }

const palette = {
  primary: {
    main: '#01529C',
    light: '#CCE7FF',
    dark: '#00336A',
    contrastText: '#FFF',
  },
  secondary: {
    main: '#43485C',
    contrastText: '#FFF',
  },
  error: {
    main: '#ED1C24',
    light: '#F5D0D1',
    contrastText: '#FFF',
  },
  warning: {
    main: '#FF8000',
    light: '#FFD4A8',
    contrastText: '#FFF',
  },
  info: {
    main: '#1991EB',
    light: '#C2DDF1',
    contrastText: '#FFF',
  },
  success: {
    main: '#008A45',
    light: '#B9DFCC',
    contrastText: '#FFF',
  },
  text: {
    primary: '#262923',
    secondary: '#78869E',
    disabled: '#26292388',
  },
} satisfies PaletteOptions

const perkinsTheme = createTheme(createBaseTheme(palette), {
  palette: {
    action: {
      hover: palette.primary.light,
      selected: alpha(palette.secondary.main, 0.5),
      focus: alpha(palette.secondary.main, 0.3),
    },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        filledError: {
          backgroundColor: lighten(palette.error.light, 0.6),
          color: palette.error.main,
        },
        filledInfo: {
          backgroundColor: lighten(palette.info.light, 0.7),
          color: palette.info.main,
        },
        filledSuccess: {
          backgroundColor: lighten(palette.success.light, 0.85),
          color: palette.success.main,
        },
        filledWarning: {
          backgroundColor: lighten(palette.warning.light, 0.75),
          color: palette.warning.main,
        },
        icon: (params: { ownerState: AlertProps }) =>
          params.ownerState.variant === 'filled'
            ? {
                color:
                  params.ownerState.severity === 'error'
                    ? palette.error.main
                    : params.ownerState.severity === 'info'
                      ? palette.info.main
                      : params.ownerState.severity === 'success'
                        ? palette.success.main
                        : palette.warning.main,
              }
            : {},
      },
    },
  },
})

export default perkinsTheme
